import { Component } from '@angular/core';

import { BookingStepsEnum } from 'src/app/models/booking/enums/booking-steps.enum';

import { AuthorisationsComponent } from '../authorisations.component';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CommandService } from 'src/app/services/common/command.service';
import { CardService } from 'src/app/services/user/card.service';

@Component({
    selector: 'booking-authorisations-mobile',
    templateUrl: './authorisations-mobile.component.html',
    styleUrls: ['./authorisations-mobile.component.scss'],
    standalone: false
})
export class AuthorisationsMobileComponent extends AuthorisationsComponent {
  step: BookingStepsEnum = BookingStepsEnum.Authorisations;

  shouldDisplay: boolean = false;

  constructor(
    protected deviceService: DeviceDetectorService, 
    protected commandService: CommandService,
    protected cardService: CardService,
     protected router: Router) {
    super(deviceService, commandService, cardService ,router);
  }

  ngOnInit() {
    super.hasAuthorisationsAsync()
      .then(response => {
        this.shouldDisplay = !response.commandResult.hasAuthorizations;
        // if (!this.shouldDisplay) {
        //   super.redirectToPayment();
        // }
      });
  }
}
